import React, { useEffect, useState } from 'react';
import { Box, FormControlLabel, Typography } from '@mui/material';

import { IOSSwitch } from 'components';

interface OptionSwitchProps {
  title: string;
  subtitle: string;
  checked: boolean;
  onClick: () => void;
}

export const OptionSwitch = ({ title, subtitle, checked: initialChecked, onClick }: OptionSwitchProps) => {
  const [checked, setChecked] = useState<boolean>(initialChecked);

  useEffect(() => {
    if (checked !== initialChecked) {
      setChecked(initialChecked);
    }
  }, [initialChecked]);

  return (
    <FormControlLabel
      control={
        <IOSSwitch
          checked={checked}
          onChange={(event, checked) => {
            setChecked(checked);
            onClick();
          }}
        />
      }
      label={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            marginLeft: 2,
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            {title}
          </Typography>
          <Typography
            color="textSecondary"
            sx={{
              fontSize: 13,
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      }
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        marginLeft: 0,
        marginRight: 0,
      }}
    />
  );
};
